import { useEffect, useState } from "react";
import CustomSelect from "./CustomSelect";
import { useGlobalContext } from "../../../../Context/Context";
import SredstvaLZOForm from "./SredstvaLZOForm";
import SredstvaNeLZOForm from "./SredstvaNeLZOForm";

const vrsteSredstvaAll = [
  {
    id: "1",
    name: "LICNA ZASTITNA OPREMA"
  },
  {
    id: "2",
    name: "KOLEKTIVNA OPREMA"
  },
  {
    id: "3",
    name: "MASINE I UREDJAJI"
  },
  {
    id: "4",
    name: "ELEKTRO OPREMA I INSTALACIJE"
  },
  {
    id: "5",
    name: "PROCESNI MATERIJALI"
  },
  {
    id: "6",
    name: "OSTALA SREDSTVA I OPREMA ZA RAD"
  }
];

function SredstvaForm({ fileNewDocument, setCurrentTab }) {
  const [vrstaSredstva, setVrstaSredstva] = useState({ id: -1, name: "" });

  const { dictionary, isLZOClicked } = useGlobalContext();

  useEffect(() => {
    if (isLZOClicked) {
      setVrstaSredstva(vrsteSredstvaAll[0]);
    }
  }, [isLZOClicked]);

  const onChange = (newValue) => {
    setVrstaSredstva(newValue);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginTop: "20px"
      }}
    >
      <CustomSelect
        label={dictionary["vrstaSredstva"]}
        allValues={vrsteSredstvaAll}
        selectedValue={vrstaSredstva}
        onSelectChange={onChange}
      />
      {vrstaSredstva.name === "LICNA ZASTITNA OPREMA" ? (
        <SredstvaLZOForm
          fileNewDocument={fileNewDocument}
          vrstaSredstva={vrstaSredstva}
          setCurrentTab={setCurrentTab}
        />
      ) : (
        <SredstvaNeLZOForm
          fileNewDocument={fileNewDocument}
          vrstaSredstva={vrstaSredstva}
        />
      )}
    </div>
  );
}

export default SredstvaForm;
